export default {"src":"/_next/static/media/ink.9107aac9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};